/* eslint-disable react/prop-types */
import {
	SimpleForm,
	TextInput,
	DateInput,
	SelectInput,
	ReferenceArrayInput,
	ReferenceInput,
	required,
	BooleanInput,
	AutocompleteInput,
	RadioButtonGroupInput,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { Typography, Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { StatusChoices, TimeLimitChoices, DefaultValues } from './meta';
import Modules from 'skylar/Modules';

// Centralized styling
const accordionStyles = {
	container: {
		mt: 1,
		mb: 1,
		width: '100%' // Ensures full width
	},
	accordion: {
		mb: 1,
		width: '100%', // Full width for accordion

		boxShadow: 1,
		borderRadius: 1,
		'&.Mui-expanded': {
			margin: '0 0 8px 0',
		}
	},
	accordionSummary: {
		backgroundColor: 'action.hover',
		borderRadius: 1,
		'&.Mui-expanded': {
			borderBottomLeftRadius: 0,
			borderBottomRightRadius: 0,
		}
	},
	accordionDetails: {
		backgroundColor: 'background.paper',
		borderTop: '1px solid',
		borderColor: 'divider',
		p: 2
	},
	topicContainer: {
		mb: 2
	},
	topicTitle: {

	}
};

// Visibility options for sessions
const visibilityChoices = [
	{ id: 1, name: 'All Users' },
	{ id: 0, name: 'Specific Groups' }
];

// Custom component for session visibility and group selection
const SessionVisibilityInput = () => {
	const publicValue = parseInt( useWatch({ name: 'public' }), 10 );

	return (
		<>
			<RadioButtonGroupInput
				source="public"
				label="Session Visibility"
				choices={visibilityChoices}
			/>
			{publicValue === 0 && (
				<ReferenceArrayInput reference="groups" source="group_ids" label="Groups" />
			)}
		</>
	);
};

const ModuleFields = ( { section } ) => <>
	<BooleanInput source={section.id + "_active"} label="Active" />
	<ReferenceInput source={section.id + "_methodology_id"} reference="methodologies">
		 <AutocompleteInput label="Methodology" />
	</ReferenceInput>
	<ReferenceInput source={section.id + "_outcome_id"} reference="outcomes">
		<AutocompleteInput label="Outcome" />
	</ReferenceInput>
	<TextInput source={section.id + "_context"} label="Conversation Context" multiline />
	<TextInput source={section.id + "_persona_context"} label="Persona Context" multiline />
</>;



export const FormFields = (
	<SimpleForm defaultValues={DefaultValues}>
		<TextInput source="name" validate={required()} />
		<DateInput source="start_date" fullWidth={false} />
		<SelectInput source="status" choices={StatusChoices} validate={required()} fullWidth={false} />
		<SelectInput source="time_limit" choices={TimeLimitChoices} validate={required()} defaultValue={0}/>

		<SessionVisibilityInput />

		<Typography variant="h5">Modules</Typography>
		<Box sx={accordionStyles.container}>
			{Modules.map((section) => (
				<Accordion
					key={section.id}
					sx={accordionStyles.accordion}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						sx={accordionStyles.accordionSummary}
					>
						<div>
						<Typography variant="h6" component="div">
							{section.title}
						</Typography>
						<Typography variant="h" component="div">
							{section.description}
						</Typography>
						</div>
					</AccordionSummary>
					<AccordionDetails sx={accordionStyles.accordionDetails}>
						<ModuleFields section={section} />
					</AccordionDetails>
				</Accordion>
			))}
		</Box>
	</SimpleForm>
);